import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/RatiosTable.vue"),
          meta: { title: "Список соотношений сторон", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/RatiosForm.vue"),
          meta: { title: "Создать соотношение сторон", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/RatiosForm.vue"),
          meta: {
            title: "Редактировать соотношение сторон",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
